var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    enableBackground: "new 0 0 66 66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61,17.3L33,1L5,17.3V65h7V32h42v33h7V17.3z M21,22h-6v-4h6V22z M31,22h-6l0-4h6V22z M41,22h-6v-4h6V22z M51,22h-6v-4h6V22   z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15,65 25,65 25,57 23,57 23,60.1 22,59.1 21,60.1 21,57 15,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28,65 38,65 38,57 36,57 36,60.1 34.9,59.1 34,60.1 34,57 28,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41,65 51,65 51,57 49,57 49,60.1 48,59.1 47,60.1 47,57 41,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15,54 25,54 25,46 23,46 23,49.1 22,48.1 21,49.1 21,46 15,46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28,54 38,54 38,46 36,46 36,49.1 35,48.1 34,49.1 34,46 28,46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41,46 41,54 51,54 51,46 49,46 49,49.1 48,48.1 47,49.1 47,46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15,35 15,43 25,43 25,35 23,35 23,38.1 22,37.1 21,38.1 21,35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28,35 28,43 38,43 38,35 36,35 36,38.1 35,37.1 34,38.1 34,35  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.e5ece2a3ed84832c896b4904cba99bba.svg";
export { ForwardRef as ReactComponent };